<td-wb-modal-notification-header modalTitle='tdWb.modalNotification.header.WELCOME_MODAL_TITLE' />

@if (isDiWelcomeModal()) {
  <td-wb-modal-notification-welcome-modal-di [currentPage]="currentPage()" />
} @else if (isFpPiaWelcomeModal()) {
  <td-wb-modal-notification-welcome-modal-fp-pia [currentPage]="currentPage()" />
}

<td-wb-modal-notification-footer buttonText="tdWb.modalNotification.footer.CONTINUE"
                                 [step]="currentPage()"
                                 (stepChange)="goToSelected($event)"
                                 [totalSubModals]="6" />
